import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWebhook = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 22,
	viewBox: "0 0 22 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M16.5937 16.2783H6.74447V17.3818C6.55314 18.5129 5.60484 19.3723 4.4638 19.3723C3.18478 19.3723 2.14793 18.2925 2.14793 16.9605C2.14793 16.1386 2.54273 15.4127 3.14562 14.9772L2.48153 13.9892C1.58001 14.6428 0.98999 15.7299 0.98999 16.9605C0.98999 18.9585 2.54527 20.5782 4.4638 20.5782C6.18433 20.5782 7.61272 19.2756 7.88923 17.5657H16.5469C16.7474 17.9249 17.121 18.1664 17.5487 18.1664C18.1882 18.1664 18.7066 17.6265 18.7066 16.9605C18.7066 16.2945 18.1882 15.7546 17.5487 15.7546C17.1523 15.7546 16.8025 15.962 16.5937 16.2783Z",
			fill: "#B37FEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.42752 16.4587C3.44753 16.407 3.4712 16.3561 3.49864 16.3063C3.71139 15.9208 4.09657 15.7045 4.49323 15.7024L8.83552 7.83429C7.55599 6.7297 7.18828 4.78763 8.04589 3.23368C9.00177 1.50165 11.1179 0.907655 12.7724 1.90696C13.7882 2.52048 14.3938 3.59193 14.4888 4.72859L13.3398 4.83397C13.2766 4.07599 12.8728 3.36145 12.1955 2.95233C11.0925 2.28613 9.68172 2.68212 9.04447 3.83681C8.42039 4.96762 8.76959 6.4067 9.82028 7.09146L10.4552 7.47497L5.53704 16.3866C5.6768 16.692 5.69187 17.0542 5.55865 17.3811C5.3961 17.8414 4.97265 18.1696 4.47587 18.1696C3.83862 18.1696 3.32202 17.6295 3.32202 16.9633C3.32202 16.7832 3.3598 16.6122 3.42752 16.4587Z",
			fill: "#B37FEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10.9412 6.23749L15.8102 15.0599L16.39 14.7097L16.3999 14.7275C16.4046 14.7246 16.4094 14.7217 16.4143 14.7187C17.518 14.0521 18.9242 14.4383 19.5551 15.5815C20.186 16.7247 19.8027 18.1918 18.6989 18.8585C18.0185 19.2695 17.2231 19.2803 16.5652 18.9603L16.0741 20.0483C17.06 20.5261 18.251 20.5089 19.2701 19.8934C20.9257 18.8934 21.5007 16.6927 20.5544 14.978C19.7 13.4297 17.8974 12.807 16.3368 13.4368L12.0165 5.60858C12.2026 5.25357 12.2131 4.81077 12.0069 4.43718C11.6915 3.8656 10.9884 3.67246 10.4365 4.0058C9.88458 4.33913 9.69291 5.0727 10.0084 5.64428C10.2088 6.00755 10.5659 6.21795 10.9412 6.23749Z",
			fill: "#B37FEB"
		})
	]
});
const ForwardRef = forwardRef(SvgWebhook);
export { ForwardRef as ReactComponent };
